<umkt-auth-layout scrollable>
  <div class="auth-back">
    <a (click)="goBack()" style="cursor: pointer;">
      <mat-icon style="margin-right: 8px;">chevron_left</mat-icon>
      {{ 'shared.buttons.back' | i18n }}
    </a>
  </div>

  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title">
          <h1 class="title-text font-highlight">
            {{ 'pages.externalChannelCompleteAddress.title' | i18n }}
          </h1>
          <p class="auth-desc">
            {{ 'pages.externalChannelCompleteAddress.subtitle' | i18n }}
          </p>
        </div>

        <umkt-loading
          *ngIf="submitting"
          [isLoading]="true"
          [size]="'md'"
          [mode]="'contained'"
          [showText]="true"
          [text]="'shared.messages.loading' | i18n"
        ></umkt-loading>

        <umkt-register-step2
          *ngIf="!submitting"
          [step2Form]="addressForm"
          [brazilStates]="brazilStates"
          [showCitySuggestions]="showCitySuggestions"
          [filteredCities]="filteredCities"
          [selectedSuggestionIndex]="selectedSuggestionIndex"
          [citySelectedFromList]="citySelectedFromList"
          [loading]="loading"
          [nextStep]="submitAddress"
          [preventLeadingSpace]="preventLeadingSpace"
          [onCityKeydown]="onCityKeydown"
          [selectCity]="selectCity"
          [goToLogin]="goToLogin"
          [isFromMobileFlow]="isFromMobileFlow"
          [customButtonTextKey]="'pages.externalChannelCompleteAddress.continueButton'"
          [hideAuthRegisterLink]="true"
        ></umkt-register-step2>
      </div>
    </div>
  </div>
</umkt-auth-layout>
